import React from "react";

import { EveButton } from "@eveworld/ui-components";

import { ConnectButton } from "@rainbow-me/rainbowkit";

import { ReactComponent as ReapersLogo } from "/src/images/ReapersLogo.svg";

const CustomConnectWallet = React.memo(function ConnectWallet(): JSX.Element {
  return (
    <div className="h-screen max-w-[560px] mx-auto relative flex flex-col items-center justify-center">
      <div>
        <ReapersLogo width={512} height={512}></ReapersLogo>
      </div>
      <br></br>
      <div className="grid gap-2">
        <ConnectButton.Custom>
          {({
            account,
            chain,
            openChainModal,
            openConnectModal,
            authenticationStatus,
            mounted,
          }) => {
            // Note: If your app doesn't use authentication, you
            // can remove all 'authenticationStatus' checks
            const ready = mounted && authenticationStatus !== "loading";
            const connected =
              ready &&
              account &&
              chain &&
              (!authenticationStatus ||
                authenticationStatus === "authenticated");

            return (
              <div
                {...(!ready && {
                  "aria-hidden": true,
                  style: {
                    opacity: 0,
                    pointerEvents: "none",
                    userSelect: "none",
                  },
                })}
              >
                {(() => {
                  if (!connected) {
                    return (
                      <EveButton
                        onClick={openConnectModal}
                        className="w-full uppercase"
                        typeClass={"primary"}
                      >
                        Connect
                      </EveButton>
                    );
                  }

                  if (chain.unsupported) {
                    return (
                      <EveButton
                        onClick={openChainModal}
                        type="button"
                        typeClass={"primary"}
                      >
                        Wrong network
                      </EveButton>
                    );
                  }

                  return <div style={{ display: "flex", gap: 12 }}></div>;
                })()}
              </div>
            );
          }}
        </ConnectButton.Custom>

        {/* <EveButton
                  typeClass="ghost"
                  className="text-xl"
                  onClick={() =>
                      window.open("https://docs.evefrontier.com/Dapp/quick-start")
                  }
              >
                  EVE Frontier Docs
              </EveButton> */}
      </div>
    </div>
  );
});

export default React.memo(CustomConnectWallet);
